import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import classes from './ChangePass.module.scss'
import { loginAuth, changePassword } from '../../API/API';
import BreadCrumb from './../../utilities/BreadCrumb/BreadCrumb'

const ChangePass = () => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [policies, setPolicies] = useState({
        containsUppercase: false,
        characterLength: false,
        alphanumeric: false,
        specialCharacter: false,
    })

    const navigate = useNavigate();

    const orange = { backgroundColor: "#EA6A47" };
    const green = { backgroundColor: "#47D316" };

    const regex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    const nums = /[123456789]/
    const caps = /[A-Z]/
    const handleNewPass = (event) => {
        setNewPassword(event.target.value);
    }

    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));

    const validator = (obj) => {
        return Object.values(obj).includes(false)
    }
    useEffect(() => {
        if (caps.test(newPassword)) {
            setPolicies((prevState) => ({
                ...prevState,
                containsUppercase: true,
            }));
        } else {
            setPolicies((prevState) => ({
                ...prevState,
                containsUppercase: false,
            }));
        }
        if (newPassword.length > 8) {
            setPolicies((prevState) => ({
                ...prevState,
                characterLength: true,
            }));
        } else {
            setPolicies((prevState) => ({
                ...prevState,
                characterLength: false,
            }));
        }
        if (nums.test(newPassword)) {
            setPolicies((prevState) => ({
                ...prevState,
                alphanumeric: true,
            }));
        } else {
            setPolicies((prevState) => ({
                ...prevState,
                alphanumeric: false,
            }));
        }
        if (regex.test(newPassword)) {
            setPolicies((prevState) => ({
                ...prevState,
                specialCharacter: true,
            }));
        } else {
            setPolicies((prevState) => ({
                ...prevState,
                specialCharacter: false,
            }));
        }
    }, [newPassword]);


    const changePasswordClick = (event) => {
        event.preventDefault()
        if (userID !== null && data !== null) {
            if (oldPassword === newPassword) {
                toast("Old Password and New Password cannot be same", {
                    icon: "❗",
                    duration: 4500
                })
                return;
            }
            if (validator(policies)) {
                toast("Please make sure you've followed every steps given below", {
                    icon: "❗",
                    duration: 4500
                })
                return;
            }
            if (newPassword !== confirmPassword) {
                toast("New Password and Confirm Password does not match", {
                    icon: "❗",
                    duration: 4500
                })
                return;
            }
            if (newPassword.split("").includes(" ")) {
                toast("New Password cannot have space in between", {
                    icon: "❗",
                    duration: 4500
                })
                return;
            }

            loginAuth(userID, oldPassword)
                .then(((response) => {
                    if (response.data.error === "SIGNUPFAIL2") {
                        toast("The Entered Old Password is Incorrect", {
                            icon: "❗",
                            duration: 4500
                        })
                    } else if (response.data.token !== null) {
                        changePassword(userID, data.empid, data.token, oldPassword, newPassword)
                            .then(response2 => {
                                if (response2.data.success === "PASSWORD CHANGED") {
                                    toast.success("Your Password has been succesfully changed", {
                                        duration: 4500
                                    })
                                    navigate('/dashboard/home')
                                } else {
                                    toast("Problem in changing password", {
                                        icon: "❗",
                                        duration: 4500
                                    })
                                }
                            })
                            .catch(error => {
                                toast("Issue in changing password please try again letter", {
                                    icon: "❗",
                                    duration: 4500
                                })
                            })

                    }
                }))
                .catch(error => {
                    toast("Sign Up Issue", {
                        icon: "❗",
                        duration: 4500
                    })
                })
        }

    }


    return (
        <>
            <BreadCrumb name="Change Password" />
            <div className={classes.Container}>
                <form className={classes.ChangePassDiv} onSubmit={changePasswordClick}>
                    <div className={classes.InputDiv}>
                        <input type="text" placeholder='Old Password' onChange={(event) => { setOldPassword(event.target.value) }} required />
                        <input type="text" placeholder='New Password' onChange={handleNewPass} required />
                        <input type="text" placeholder='Confirm New Password' onChange={(event) => { setConfirmPassword(event.target.value) }} required />
                    </div>
                    <div className={classes.TodoList}>
                        <div className={classes.Todos}>
                            <span style={policies.containsUppercase ? green : orange}></span>
                            <p>Contains atleast 1 Uppercase letter</p>
                        </div>
                        <div className={classes.Todos}>
                            <span style={policies.characterLength ? green : orange}></span>
                            <p>Length should be more than 8 character</p>
                        </div>
                        <div className={classes.Todos}>
                            <span style={policies.alphanumeric ? green : orange}></span>
                            <p>Contains atleast 1 alphanumeric character</p>
                        </div>
                        <div className={classes.Todos}>
                            <span style={policies.specialCharacter ? green : orange}></span>
                            <p>Contains atleast 1 special character</p>
                        </div>
                        <button type='submit'>
                            Change Password
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default ChangePass
